const clearHead = (head: string) => {
  // remove yoast schema because it will be added by SeoSchema component.
  const regex = /<script type="application\/ld\+json"[^>]*>[\s\S]*?<\/script>/g;
  return head.replace(regex, '');
};

export default clearHead;
